module.exports = __webpack_public_path__ + "img/carouselLeft.85e90a87.svg";